import SysTable from "app/class/sys-table";
import { useTables } from "./useTables";

const useUniqueTable = (tableName: string): SysTable | null => {
    const { data } = useTables();
    return data?.find(table => table.name === tableName) || null;
};

export default useUniqueTable;